class Customer.UserProfileAttribute extends Backbone.Model
  defaults:
    definition:
      {}
    value:
      []

  isRequired: =>
    _.findWhere(@get('definition').validations, validation_type: 'presence') != undefined

class Customer.UserProfileAttributeCollection extends Backbone.Collection
  model: Customer.UserProfileAttribute
  url: '/profiles/api/attributes/update'

  saveChanges:({profileID, added, deleted}) =>
    $.ajax
      url: @url
      type: 'POST'
      contentType: 'application/json'
      data: JSON.stringify
        profile_id: profileID
        user_profile_attributes_definitions:
          added: added
          deleted: deleted
      success: (response) =>
        if response.success
          @trigger 'profile_custom_attributes:change', response.profile
        else
          showError(response.error_message)
      error: =>
        showError('An error occurred saving the attributes')
        @trigger 'profile_custom_attributes:restore'
